export enum JackpotThemeType {
    Light,
    Dark
}

export enum KnownJackpotId {
    Daily = 8000,
    Twilight = 8001,
    HourlyCaptain8 = 8002,
    MillionaireGenie = 6,
    AgeOfTheGodsFranchises = 200019,
}

export enum JackpotType {
    Daily = "Daily",
    HighNoon = "HighNoon",
    Twilight = "Twilight",
    Party = "Party",
    HourlyCaptain8 = "HourlyCaptain8",
    MillionaireGenie = "MillionaireGenie",
    AgeOfGods = "AgeOfTheGodsFranchises",
    Titan = "Titan",
    VegasMillions = "VegasMillions",
    JackpotKing = "JackpotKing",
    JackpotBet = "JackpotBet",
    Amusnet = "Amusnet"
}


